import type { CompanyInfo, NavItem, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'ADEKAS',
    description: "ADEKAS iz Sarajeva izvodi građevinske radove, adaptacije i renoviranja te elektro i vodo instalacije. Profesionalan pristup, provjerena kvaliteta i besplatne konsultacije.",
    url: getOrigin(),
    ogImage: 'https://northbeam-builders.cdn.modulify.website/images/adekas/breka-hills.jpg'
}

export const company: CompanyInfo = {
    shortName: 'ADEKAS',
    descriptor: "Građevinske usluge",
    location: "Sarajevo, Bosna i Hercegovina",
    serviceArea: "Sarajevo i okolina",
    phone: '',
    phoneHref: '',
    email: '',
    socials: []
}

export const contactHref = '/kontakt'

export const navigation: Array<NavItem> = [
    { label: "Naslovna", href: '/' },
    { label: "O nama", href: '/o-nama' },
    { label: "Usluge", href: '/usluge' },
    { label: "Projekti", href: '/projekti' }
]
